import React from 'react';
import { connect } from 'react-redux';

import classes from './CardDetail.scss';

import InputMaterial from '../../../UI/InputMaterial/InputMaterial';
import { toggleFlipCard } from '../../../../store/actions/index';
import Cleave from 'cleave.js/react';

const cardDetail = (props) => {

    return (
        <div>
            <div className={classes.InputContainer}>
                <div className={`u-relative u-width100Percent`}>
                    <Cleave
                        className={[classes.CustomInput, classes.CardInput].join(' ')}
                        options={{creditCard: true, onCreditCardTypeChanged: props.typeChange}}
                        onChange={props.creditCardChange.bind(this)} />
                    <span className={classes.Bar}></span>
                    <label className={[classes.Label, props.creditCardValue !== '' ? classes.LabelActive : null].join(' ')} style={{ left: '4rem' }}>Card Number</label>
                </div>
            </div>
            <div className={classes.InputContainer}>
                <div className={classes.InputLarge}>
                    {/* <Tooltip showTooltip={props.cardNameTooltip} type="validationCardName" aria-label="Enter Name" /> */}
                    <InputMaterial
                        type='text'
                        label='Name on Card'
                        alignment='left'
                        onChange={props.nameChange}
                        value={props.nameValue}
                        name='cardName'
                        // style={{borderBottom: !props.cardNameValid ? '2px solid #ff7d7d' : '1px solid #dee2ed'}} 
                        />
                </div>
                <div className={classes.InputSmall}>
                    <div className={`u-relative u-width100Percent`}>
                        <Cleave
                        className={classes.CustomInput}
                        options={{date: true, delimiter: '/', blocks: [2,2], datePattern: ['m', 'y']}}
                        onChange={props.expiryDateChange.bind(this)} />
                        <span className={classes.Bar}></span>
                        <label className={[classes.Label, props.expiryDateValue !== '' ? classes.LabelActive : null].join(' ')} style={{ left: 0 }}>Expiry</label>
                    </div>
                </div>
                <div className={classes.InputSmall}>
                    {/* <Tooltip showTooltip={props.cvvTooltip} type="validationCVV" aria-label="Enter CVV" /> */}
                    <InputMaterial
                        type='text'
                        label='CVV'
                        alignment='left'
                        onChange={props.cvvChange}
                        onFocus={() => props.onToggleFlipCard()}
                        onBlur={() => props.onToggleFlipCard()}
                        value={props.cvvValue}
                        maxLength='4'
                        name='cardCVV'
                        // style={{borderBottom: !props.cvvValid ? '2px solid #ff7d7d' : '1px solid #dee2ed'}} 
                        />
                </div>
            </div>
        </div>
    );
} 

const mapDispatchToProps = dispatch => {
    return {
        onToggleFlipCard: () => dispatch(toggleFlipCard())
    }
}

export default connect(null, mapDispatchToProps)(cardDetail);


// WEBPACK FOOTER //
// ./src/components/Payment/Common/CardDetail/CardDetail.js